import React, {ForwardedRef, forwardRef} from 'react'
import {LocationsMenuLink} from '../../Locations/shared/Layout/MenuLink'
import {StatsMenuLink} from '../../Stats/shared/Layout/MenuLink'

const DesktopLeftMenu = forwardRef(
  (props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div className="bg-surface p-sm flex w-56 shrink-0 flex-col" ref={ref}>
        <nav className="gap-y-xxs flex grow flex-col overflow-y-auto">
          <LocationsMenuLink />

          <StatsMenuLink />
        </nav>
      </div>
    )
  },
)

export {DesktopLeftMenu}
